var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.993 511.993",
    style: {
      enableBackground: "new 0 0 511.993 511.993"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501.039,182.351L329.395,10.707c-14.281-14.281-36.642-14.268-50.911,0l-267.76,267.76    c-7.026,7.026-10.934,16.675-10.716,26.462c0.205,9.486,4.089,18.237,10.946,24.683l36.558,36.558    c6.332,6.344,16.349,7.08,23.544,1.761c20.993-15.505,50.211-13.484,67.971,4.722c18.194,18.641,20.408,47.925,5.144,68.122    c-5.446,7.207-4.746,17.314,1.64,23.7l36.787,36.787c6.845,6.839,16.168,10.729,25.696,10.729c0.253,0,0.513-0.006,0.766-0.012    c9.486-0.205,18.237-4.083,24.683-10.946l267.525-267.543c7.026-7.02,10.928-16.663,10.716-26.456    C511.779,197.548,507.902,188.798,501.039,182.351z M304.308,36.102c-0.084,0.048-0.223,0.072-0.338,0.096L291.282,23.51    L304.308,36.102z M208.059,475.548l-26.601-26.601c16.228-32.897,10.192-74.177-16.536-101.568    c-26.637-27.271-68.122-33.446-101.833-16.801L36.44,303.934l267.506-267.5l171.613,171.613L208.059,475.548z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.47,
    y: 75.508,
    transform: "matrix(0.7116 -0.7025 0.7025 0.7116 -4.013 207.3298)",
    width: 36.176,
    height: 66.092,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 385.973,
    y: 228.974,
    transform: "matrix(0.7025 -0.7117 0.7117 0.7025 -66.2688 365.5246)",
    width: 36.184,
    height: 66.102,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.356,
    y: 151.88,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -35.0063 285.7649)",
    width: 36.177,
    height: 66.517,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketWhite);
export default __webpack_public_path__ + "static/media/ticket_white.16917b373d5508416acd83d7b081aa85.svg";
export { ForwardRef as ReactComponent };